module.exports = __webpack_public_path__ + "static/media/gateway-function.ec32c6c8.svg";